import React from 'react'
import { Box, Typography } from '@mui/material'

export const MAINTENANCE_TITLE = 'Planned maintenance'

export const MAINTENANCE_MESSAGE =
  'There will be a planned maintenance affecting CSCS Smart Check on Saturday 22 August between 09:00 and 13:00 (UK time). The platforms will be upgraded, with the service experiencing approximately 30 minutes of downtime during the maintenance window.'

/**
 * Notice colours mirror the shared maintenance banner in cscs-angular-frontend
 * (src/app/shared/maintenance-banner) so both platforms read as one service.
 */
const NOTICE_BACKGROUND = '#FDF6E3'
const NOTICE_BORDER = '#E5E5E5'
const NOTICE_ACCENT = '#D9822B'
const NOTICE_TITLE_COLOR = '#4A4A4A'
const NOTICE_TEXT_COLOR = '#666666'

const MaintenanceBanner: React.FC = () => {
  return (
    <Box
      role="alert"
      data-testid="maintenance-banner"
      sx={{
        width: '100%',
        padding: '20px 0',
        backgroundColor: NOTICE_BACKGROUND,
        borderLeft: `4px solid ${NOTICE_ACCENT}`,
        borderBottom: `1px solid ${NOTICE_BORDER}`,
        '@media (max-width: 590px)': {
          padding: '15px 0',
        },
      }}
    >
      <Box
        sx={{
          width: '70%',
          margin: '0 auto',
          '@media (max-width: 590px)': {
            width: '100%',
            padding: '0 18px',
          },
        }}
      >
        <Typography
          component="h4"
          fontFamily="MetaProBold"
          sx={{
            color: NOTICE_TITLE_COLOR,
            fontSize: 18,
            fontWeight: (theme) => theme.typography.fontWeightMedium,
            margin: '0 0 5px 0',
          }}
        >
          {MAINTENANCE_TITLE}
        </Typography>
        <Typography
          sx={{
            color: NOTICE_TEXT_COLOR,
            fontSize: 14,
            lineHeight: 1.4,
            margin: 0,
          }}
        >
          {MAINTENANCE_MESSAGE}
        </Typography>
      </Box>
    </Box>
  )
}

export default MaintenanceBanner
